export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 160,
    fixed: 'left',
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'serviceByName',
    align: 'left',
    minWidth: 100,
    title: '客服名字',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'orgName',
    align: 'left',
    width: 100,
    title: '负责机构',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'custName',
    align: 'left',
    minWidth: 100,
    title: '客户名称',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'vehicleModel',
    align: 'left',
    minWidth: 100,
    title: '车型',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'vehicleLength',
    align: 'left',
    minWidth: 100,
    title: '车长',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'vehicleQty',
    align: 'left',
    minWidth: 100,
    title: '车辆数量',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'carrierName',
    align: 'left',
    minWidth: 120,
    title: '承运商名称',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'vehicleNo',
    align: 'left',
    minWidth: 100,
    title: '车牌号',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'driverName',
    align: 'left',
    minWidth: 100,
    title: '司机姓名',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originProvinceName',
    align: 'left',
    minWidth: 120,
    title: '始发地省份',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originCityName',
    align: 'left',
    minWidth: 120,
    title: '始发地城市',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originDistrictName',
    align: 'left',
    minWidth: 120,
    title: '始发地区县',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originPlace',
    align: 'left',
    width: 120,
    title: '始发地园区',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originLongitude',
    align: 'left',
    width: 120,
    title: '始发地经度',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originLatitude',
    align: 'left',
    width: 120,
    title: '始发地纬度',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originName',
    align: 'left',
    width: 170,
    title: '始发地发货方名称',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originContactName',
    align: 'left',
    width: 170,
    title: '始发地联系人姓名',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originContactMobile',
    align: 'left',
    width: 150,
    title: '始发地联系人手机',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originContactPhone',
    align: 'left',
    width: 150,
    title: '始发地固定电话',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originContactEmail',
    align: 'left',
    width: 150,
    title: '始发地联系人Email',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originElectronicFence',
    align: 'left',
    width: 170,
    title: '始发地电子围栏半径',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'planPickDatetimeBegin',
    align: 'left',
    width: 170,
    title: '计划提货时间开始',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'planPickDatetimeEnd',
    align: 'left',
    width: 170,
    title: '计划提货时间截止',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'needLoadingName',
    align: 'left',
    width: 150,
    title: '是否需要装货',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'pickDateTime',
    align: 'left',
    width: 150,
    title: '实际提货时间',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'pickOvertimeName',
    align: 'left',
    width: 150,
    title: '是否提货超时',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationProvinceName',
    align: 'left',
    width: 120,
    title: '目的地省份',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationCityName',
    align: 'left',
    width: 120,
    title: '目的地城市',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationDistrictName',
    align: 'left',
    width: 120,
    title: '目的地区县',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationPlace',
    align: 'left',
    width: 120,
    title: '目的地园区',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationLongitude',
    align: 'left',
    width: 150,
    title: '目的地地图经度',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationLatitude',
    align: 'left',
    width: 150,
    title: '目的地地图纬度',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationName',
    align: 'left',
    width: 170,
    title: '目的地收货方名称',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationContactName',
    align: 'left',
    width: 170,
    title: '目的地联系人姓名',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationContactMobile',
    align: 'left',
    width: 150,
    title: '目的地联系人手机',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationContactPhone',
    align: 'left',
    width: 150,
    title: '目的地固定电话',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationContactEmail',
    align: 'left',
    width: 150,
    title: '目的地联系人Email',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationElectronicFence',
    align: 'left',
    width: 170,
    title: '目的地电子围栏半径',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'planReceiveDatetimeBegin',
    align: 'left',
    width: 170,
    title: '计划到货时间开始',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'planReceiveDatetimeEnd',
    align: 'left',
    width: 170,
    title: '计划到货时间截止',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'needUnloadingName',
    align: 'left',
    width: 150,
    title: '是否需要卸货',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'receiveDateTime',
    align: 'left',
    width: 170,
    title: '实际到货时间',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'receiveOvertimeName',
    align: 'left',
    width: 150,
    title: '是否到货超时',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'goodsName',
    align: 'left',
    width: 170,
    title: '物名称合集',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'goodsQty',
    align: 'left',
    width: 100,
    title: '总件数',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'goodsWeight',
    align: 'left',
    width: 170,
    title: '预计总重量kg',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'goodsVolume',
    align: 'left',
    width: 170,
    title: '预计总体积m³',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'goodsValue',
    align: 'left',
    width: 100,
    title: '总货值',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'factWeight',
    align: 'left',
    width: 170,
    title: '实际总重量kg',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'factVolume',
    align: 'left',
    width: 170,
    title: '实际总体积m³',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'incomeAmount',
    align: 'left',
    width: 170,
    title: '应收运费合计',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'incomeCostAmount',
    align: 'left',
    width: 170,
    title: '应收费用合计',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'incomeTotalAmount',
    align: 'left',
    width: 170,
    title: '应收合计',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'payAmount',
    align: 'left',
    width: 170,
    title: '应付运费合计',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'payCostAmount',
    align: 'left',
    width: 170,
    title: '应付费用合计',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'settlementStatusName',
    align: 'left',
    width: 100,
    title: '结算状态',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'settlementCode',
    align: 'left',
    width: 150,
    title: '结算单编码',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'settlementNo',
    align: 'left',
    width: 150,
    title: '结算单号',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'settlementBuildTime',
    align: 'left',
    width: 170,
    title: '结算单生成时间',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'wayBillStatusName',
    align: 'left',
    width: 100,
    title: '运单状态',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createByName',
    align: 'left',
    width: 120,
    title: '创建人名字',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createTime',
    align: 'left',
    width: 170,
    title: '创建时间',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyByName',
    align: 'left',
    width: 120,
    title: '修改人名字',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyTime',
    align: 'left',
    width: 170,
    title: '修改时间',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
];
